var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui-fixed-watchlist-button",on:{"click":_vm.openWatchlistPage}},[_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.WATCHLIST_SELECTED_ITEM,"title":"Watchlist"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }